import React from 'react'
import {Card} from "./Card"
import './App.css'

/* import img00 from "./ProjID0.png";
import img01 from  "./ProjID1.png";
import img02 from  "./ProjID2.png";
import img03 from  "./ProjID3.png"; */
/* import img04 from  "./ProjID4.884b0d3c6aef25e5e63b.png"; */

const TimeLine2 = (props) => {

  let MyProjects = [];

  let MyProjectsInEnglish = [
    {
      id: 4,
      title: "Photo Gallery from Pixels API",
      skill: "HTML, CSS, JS, React, hooks, Boostrap,",
      hostedBy: "Git Hub",
      description: "An interactive gallery to search images and see the main info about them",
      lesson: "I started to understand the functions to access the API's data and renderize it where I want and how I want. This time I used effects from CodePen. I made the page responsive.",
      year: 2022,
      url: 'https://caro-escala.github.io/Photo-Gallery-from-Pixels-API/',
      gitUrl: "https://github.com/caro-escala/Photo-Gallery-from-Pixels-API",
      imgSrc: './static/media/ProjID4.884b0d3c6aef25e5e63b.png' ,
      alt: "Page of the Photo Gallery",
    },
    {
      id: 3,
      title: "Caro es Casino",
      skill: "HTML, CSS, JS, React",
      hostedBy: "Netlify",
      description: "An interactive game of chances, like a virtual slot machine hosted in 'my Casino'",
      lesson: "The purpose of this project was to train the tool 'React Create App' and start to use 'states' in the components. The page wasn't though to be responsive. I coded the effects myself, by using different class styles, events listener and setting times-out.",
      year: 2022,
      url: 'http://caroescasino.netlify.app/',
      gitUrl: "https://github.com/caro-escala/Caro_es_Casino",
      imgSrc: './static/media/ProjID3.a3ff98674e3d39d53a90.png',
      alt: "Page of the casino",
    },
    {
      id: 2,
        title: "My Darkest Side",
        skill: "HTML, CSS, JS, React",
        hostedBy: "Netlify",
        description: "A personal blog in which I share my thoughs about sencitives matters",
        lesson: "My first aproach to the use of React, components and the renderization of content in html format from an jsx file.",
        year: 2021,
        url: 'https://caro-escala.github.io/My-Darkest-Side/',
        gitUrl: "https://github.com/caro-escala/My-Darkest-Side",
        imgSrc: '/static/media/ProjID2.22656f45bab00e332823.png',
        alt: "Page of My Darkest Side",
      },
    {
      id: 1,
      title: "My most poetic side",
      skill: "HTML, CSS, JS, Boostrap, Facebook Plugins",
      hostedBy: "Netlify",
      description: "A personal blog about amazing species of Planet Earth",
      lesson: "I used Boostrap to design the page for each article mainly, and the rest was all on me. I tried to care the visual confort of the reader, to make the page responsive and add improvements with each publication. My personal aim here was to coded all the js for the index page and the section of 'all publications' in order to make them automatic, meaning to be able to update them without re-writing the html. The project was to big for my knowledge at the time, giving the fact that I wanted to have the version in English and Spanish.",
      year: 2021,
      url: 'https://mymostpoeticsidebycm.netlify.app/',
      gitUrl: "https://github.com/caro-escala/My-most-poetic-side-by-cm",
      imgSrc:  './static/media/ProjID1.a4794663743fd95c1211.png',
      alt: "Inicial page of the blog",
    },
    {
      id: 0,
      title: "The Colour Guessing Game",
      skill: "HTML, CSS, JS",
      hostedBy: "Netlify",
      description: "An interactive game to use your wit",
      lesson: "A single page in which I put in practise the use of JS to stablish randomly the riddle of the game and then to manipulate the html and also the css. I coded the effects myself using events listener.",
      year: 2021,
      url: 'https://thecolourguessinggamebycm.netlify.app/',
      gitUrl: "https://github.com/caro-escala/The-colour-guessing-game-by-cm",
      imgSrc: './static/media/ProjID0.4be111640358af7b91b8.png',
      alt: "Inicial page of the game",
    },
 
  ];

  let MyProjectsInSpanish = [
    {
      id: 4,
      title: "Galería de Fotos desde la API de Pixels",
      skill: "HTML, CSS, JS, React, hooks, Boostrap",
      hostedBy: "Git Hub",
      description: "Una galería interactiva para la búsqueda de imágenes y visualizar la principal información sobre las mismas",
      lesson: "Con este proyecto comencé a comprender el funcionamiento de acceso a la información de una API y cómo renderizarla a gusto. En esta oportunidad usé efectos de la librería CodePen. Configuré la página para que sea responsive.",
      year: 2022,
      url: 'https://caro-escala.github.io/Photo-Gallery-from-Pixels-API/',
      gitUrl: "https://github.com/caro-escala/Photo-Gallery-from-Pixels-API",
      imgSrc: './static/media/ProjID4.884b0d3c6aef25e5e63b.png' ,
      alt: "Page of the Photo Gallery",
    },
    {
      id: 3,
      title: "Caro es Casino",
      skill: "HTML, CSS, JS, React",
      hostedBy: "Netlify",
      description: "Un juego interactivo de azar, como una máquina traga-monedas virtual, situada en 'mi Casino'",
      lesson: "El propósito de este proyecto fue entrenar la herramienta 'React Create App' y comnezar a usar estados en los componentes. La página no fue pensada para ser responsive. Escribí el código para programar los efectos artesanalmente, usando diferentes clases y estilos, eventos de escucha y configurando los tiempos de ejecución.",
      year: 2022,
      url: 'http://caroescasino.netlify.app/',
      gitUrl: "https://github.com/caro-escala/Caro_es_Casino",
      imgSrc: './static/media/ProjID3.a3ff98674e3d39d53a90.png',
      alt: "Page of the casino",
    },
    {
      id: 2,
        title: "Mi lado más oscuro",
        skill: "HTML, CSS, JS, React",
        hostedBy: "Netlify",
        description: "Blog personal en el cual comparto mis pensamientos sobre temas delicados...",
        lesson: "Mi primer acercamiento al uso de React, los componentes y la renderización de contenido en formato html a partir de un archivo jsx.",
        year: 2021,
        url: 'https://caro-escala.github.io/My-Darkest-Side/',
        gitUrl: "https://github.com/caro-escala/My-Darkest-Side",
        imgSrc: './static/media/ProjID2.22656f45bab00e332823.png',
        alt: "Page of My Darkest Side",
      },
    {
      id: 1,
      title: "Mi lado más poético",
      skill: "HTML, CSS, JS, Boostrap, Facebook Plugins",
      hostedBy: "Netlify",
      description: "Blog personal sobre especies increíbles del Planeta Tierra",
      lesson: "Usé Boostrap para diseñar la página de cada artículo principalmente, pero el resto fue todo hecho por mí. Traté de considerar el confort visual del lector, hacer la página responsive e incorporar mejoras con cada nueva publicación. Mi meta en este caso fue codificar el js para la página índice y para la sección de publicaciones históricas de manera de hacerlas automáticas, es decir, que se actualicen sin tener que re-escribir el html. El proyecto era muy ambicioso para mi conocimiento en programación de ese entonces, dado que quería contar con las versiones de mis artículos en inglés y español. Aún así lo llevé a cabo.",
      year: 2021,
      url: 'https://mymostpoeticsidebycm.netlify.app/',
      gitUrl: "https://github.com/caro-escala/My-most-poetic-side-by-cm",
      imgSrc:  './static/media/ProjID1.a4794663743fd95c1211.png',
      alt: "Inicial page of the blog",
    },
    {
      id: 0,
      title: "El juego de adivinanza del color",
      skill: "HTML, CSS, JS",
      hostedBy: "Netlify",
      description: "Un juego interatico en el que usar tu ingenio",
      lesson: "Desarrollo de una única página, en la que puse en práctica por primera vez el uso de JS en relación al html y css, estableciendo de manera aleatoria el enigma para el juego y manipulando el texto del html y los colores del css a través de js. Codifiqué los efectos por mi misma, usando eventos de escucha. ",
      year: 2021,
      url: 'https://thecolourguessinggamebycm.netlify.app/',
      gitUrl: "https://github.com/caro-escala/The-colour-guessing-game-by-cm",
      imgSrc: './static/media/ProjID0.4be111640358af7b91b8.png',
      alt: "Inicial page of the game",
    },
 
  ];

  if (props.language === "English") {
    MyProjects = MyProjectsInEnglish;
  } else if (props.language === "Spanish") {
    MyProjects = MyProjectsInSpanish;
  }


  console.log(MyProjects);

    return (
    <div>
        <div className='projectsContainer'>

           {/* cada proyecto */}
          {MyProjects.map((proj) =>{
            return <Card
            language={props.language}
            key={proj.id}
            title={proj.title} 
            description={proj.description}
            skill={proj.skill}
            hosted={proj.hostedBy}
            lesson={proj.lesson}
            year={proj.year}
            url={proj.url} 
            gitUrl={proj.gitUrl}
            imgSrc={proj.imgSrc}
            alt={proj.alt}
            /> 
          })}
      </div>
    </div>
    )
} 

export default TimeLine2
